import { http } from '.';
import { useQuery } from '@tanstack/react-query';

interface QueryOptions {
  url: string;
  cacheKey?: string;
  params?: Record<string, string | number | boolean | string[] | undefined>;
  enabled?: boolean;
}

export const queryConfig =
  ({ isBlob = false }: { isBlob?: boolean }) =>
  <T>(options: QueryOptions) => {
    const { url, cacheKey, params, enabled = true } = options;

    return useQuery({
      queryFn: async (): Promise<{ status: number; payload: T }> => {
        const { status, data: result } = await http.get(url, {
          params: { ...params },
          paramsSerializer: { indexes: null },
          responseType: isBlob ? 'blob' : 'json',
        });

        if (isBlob) {
          return { status, payload: result as T };
        }

        return { status, payload: result };
      },
      queryKey: [cacheKey, params],
      enabled,
    });
  };
